export class DialogModelOutstandingPaymentHistory {
    constructor(
      public outstandingData: any
    ) {}
  }